import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form, Button, Spinner } from "react-bootstrap";
import auth from "../../Account/Auth";
import be from "../../BE";
import Heading from "./Heading";
import Upgrade from "./Upgrade";
import Credits from "./Credits";
import Subscription from "./Subscription";
import PhoneNumberInput, {
  defaultCountryOptions,
} from "../../Components/Input/PhoneNumber";

export default function Whatsapp() {
  const history = useHistory();
  const { t } = useTranslation(["integrations"]);

  const [selectedCountry, setSelectedCountry] = useState(
    defaultCountryOptions[1]
  );
  const [inputValue, setInputValue] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [credits, setCredits] = useState(0);
  const [currentPriceId, setCurrentPriceId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [status, setStatus] = useState(0);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [processing, setProcessing] = useState(false);

  // Load initial WhatsApp settings
  useEffect(() => {
    setLoadingInfo(true);
    auth
      .isAuthenticated()
      .then(() =>
        be.get("account-jubilant", "/settings/whatsapp", {}, true, true)
      )
      .then((res) => {
        const match = defaultCountryOptions.find((o) => o.dial === res.country);
        const initial = match || defaultCountryOptions[1];
        setSelectedCountry(initial);
        setInputValue(res.number);
        setWhatsapp(`${res.country}${res.number}`);
        setCredits(res.credits);
        setCurrentPriceId(res.priceId);
        setCustomerId(res.customerId);
      })
      .catch((error) => {
        console.error("[whatsapp] fetching error:", error);
        if (error?.response?.status === 401) history.push("/login");
      })
      .finally(() => setLoadingInfo(false));
  }, [history]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputValue) return;
    setProcessing(true);
    setStatus(0);

    auth
      .isAuthenticated()
      .then(() => {
        const payload = { country: selectedCountry.dial, number: inputValue };
        return be.post(
          "account-jubilant",
          "/settings/whatsapp",
          payload,
          true,
          true
        );
      })
      .then(() => {
        setWhatsapp(`${selectedCountry.dial}${inputValue}`);
        setStatus(200);
      })
      .catch((error) => {
        console.error("[whatsapp] save error:", error);
        if (error?.response?.status === 401) history.push("/login");
        else setStatus(error?.response?.status || 500);
      })
      .finally(() => setProcessing(false));
  };

  return (
    <>
      <Heading />
      <Form onSubmit={handleSubmit} className="tw-max-w-sm">
        <div className="tw-flex tw-items-center">
          <PhoneNumberInput
            selectedCountry={selectedCountry}
            onSelectCountry={setSelectedCountry}
            number={inputValue}
            onChangeNumber={setInputValue}
            disabled={loadingInfo}
            required
          />
          <Button
            variant="primary"
            type="submit"
            disabled={loadingInfo || processing}
            className="tw-h-[40px] tw-px-5 tw-py-2 tw-rounded-r-lg !tw-rounded-l-none"
          >
            {processing ? (
              <Spinner size="sm" animation="border" variant="light" />
            ) : (
              t("whatsapp.save")
            )}
          </Button>
        </div>
      </Form>

      {status > 400 && status < 600 && (
        <p className="text-danger">{t("whatsapp.error")}</p>
      )}
      {status === 200 && (
        <p className="text-success">{t("whatsapp.success")}</p>
      )}

      {/*
      {!loadingInfo && (
        <div className="tw-mt-3">
          {userPlan === "professional" ? (
            <>
              <Credits credits={credits} />
              <div className="tw-flex tw-flex-col tw-md:tw-flex-row tw-gap-3 tw-my-3">
                {TIER_IDS.map((pid, i) => (
                  <Subscription
                    key={pid}
                    price={[10, 20, 50][i]}
                    notifications={[100, 200, 500][i]}
                    customerId={customerId}
                    currentPriceId={currentPriceId}
                    priceId={pid}
                    cancel={null}
                    update={null}
                  />
                ))}
              </div>
            </>
          ) : (
            <Upgrade />
          )}
        </div>
      )}
      */}
    </>
  );
}
